/* Used global Wordpress php variables to the ajax requests */
/* global phpvars */

/**
 * Global Blog Class
 */
export class Blog {

	/**
	 * Constructor
	 *
	 * @param {node} container
	 * @return {void}
	 */
	constructor( container ) {

		this.blogContainer = document.querySelector( container );
		if ( ! this.blogContainer ) {

			return false;

		}

		this.loopContainer = this.blogContainer.querySelector( '.js-blog-loop' );
		this.blogTrigger = this.blogContainer.querySelector( '.js-blog-trigger' );
		this.bodyEl = document.querySelector( 'body' );
		this.footer = document.querySelector( 'footer' );
		if ( ! this.blogTrigger || ! this.loopContainer ) {

			return false;

		}

		this.breakpoint = 859; //859;//1110; //1025;//768;
		this.mediaQuery = window.matchMedia( `(min-width:${ this.breakpoint }px)` );

		this.order= this.blogContainer.dataset.order;
		this.orderby= this.blogContainer.dataset.orderby;
		this.postsPerPage = this.blogContainer.dataset.pp;
		this.useDefaultQuery = this.blogContainer.dataset.useDefaultQuery;
		this.author = this.blogContainer.dataset.author;
		this.categories = this.blogContainer.dataset.categories;

		this.instanceVars = phpvars;
		this.isLoading = false;
		this.loadedAll = false;
		this.paged = 1;
		this.isSeen = ( el ) => {

			if ( this.footer && this.footer.getBoundingClientRect().top <= window.innerHeight ) {

				return false;

			}

			return el.getBoundingClientRect().bottom <= window.innerHeight;

		};

		// this.addObserver();

		this.mediaQuery.addEventListener( 'change', this.handleMediaQuery );
		this.handleMediaQuery( this.mediaQuery );

	}

	/**
	 * handleMediaQuery
	 *
	 * @param {object} e
	 */
	handleMediaQuery = ( e ) => {

		if ( e.matches ) {

			this.addObserver( 'bottom' );

		} else {

			this.addObserver( 'top' );

		}

	}

	/**
	 * Add Observer
	 *
	 * @param {string} position
	 * @return {void}
	 */
	addObserver( position ) {

		const positionCheck = position === 'bottom' ? 'bottom' : 'top';

		window.addEventListener( 'scroll', () => {

			if ( this.isSeen( this.blogTrigger )  && !( this.footer && this.footer.getBoundingClientRect()[positionCheck] <= window.innerHeight ) ) {

				this.getPosts();

			}

		} )

	}

	/**
	 * Get Posts
	 *
	 * @return {void}
	 */
	getPosts() {

		if ( this.isLoading === true || this.loadedAll === true || ( this.footer && this.footer.getBoundingClientRect().bottom <= window.innerHeight ) ) {

			return;

		}

		this.paged++;
		this.isLoading = true;
		this.blogContainer.classList.add( 'c-blog--loading' );

		fetch( this.instanceVars.ajaxUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams( {
				action: 'getBlogPosts',
				bn: this.instanceVars.security,
				paged: this.paged,
				pp: this.postsPerPage,
				order: this.order,
				orderby: this.orderby,
				useDefaultQuery: this.useDefaultQuery,
				author: this.author,
				categories: this.categories,

			} ),
		} ).then( ( response ) => {

			return response.json();

		} ).then( ( response ) => {

			if ( response.data.results !== '' ) {

				if ( this.footer && this.footer.getBoundingClientRect().bottom <= window.innerHeight ) {

					this.isLoading = false;
					return;

				}

				this.loopContainer.insertAdjacentHTML( 'beforeend', response.data.results );

			} else {

				this.loadedAll = true;

			}

			this.blogContainer.classList.remove( 'c-blog--loading' );
			this.isLoading = false;

		} ).catch( ( ) => {

			this.blogContainer.classList.remove( 'c-blog--loading' );
			this.isLoading = false;

		} );

	}

}
